import { formatToDate } from '@/utilities/TimeUtility';
import { BaseModel } from 'sjs-base-model';

export default class EntitlementListModel extends BaseModel {
  userId: string = '';
  productId: string ='';
  validFrom: string = '';
  validTo: string = '';
  createdDate: string = '';
  updatedDate: string = '';

  constructor(data: Partial<EntitlementListModel>) {
    super();
    this.update({
      userId: data.userId,
      productId: data.productId,
      validFrom: data.validFrom,
      validTo: data.validTo,
      createdDate: data.createdDate,
      updatedDate: data.updatedDate
    });
  }
}

export class EntitlementModel extends BaseModel {
  userId: string = '';
  productId: string ='';
  validFrom: string = '';
  validTo: string = ''; 

  constructor(data: Partial<EntitlementModel>) {
    super();
    this.update({
      userId: data.userId,
      productId: data.productId,
      validFrom: data.validFrom,
      validTo: data.validTo,
    });
  }
}

export class UserEntitlementListModel extends BaseModel {
  eexProductId: string = '';
  productName: string ='';
  validFrom: string = '';
  validTo: string = '';

  constructor(data: Partial<UserEntitlementListModel>) {
    super();
    this.update({
      eexProductId: data.eexProductId,
      productName: data.productName,
      validFrom: formatToDate(data.validFrom || ''),
      validTo: formatToDate(data.validTo || ''),
    });
  }
}